/**
 * SeoHead — injects per-page SEO tags using React 19 native document metadata
 * hoisting (title / meta / link rendered here are hoisted into <head>).
 * JSON-LD is rendered inline (valid anywhere in the document for crawlers).
 *
 * Decoupled + reusable: the public renderer passes the backend-built `meta`
 * object and `schemaJson` string straight through — no page-specific logic here.
 */
export function SeoHead({ meta, schemaJson }) {
  if (!meta) return null;
  return (
    <>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description || ""} />
      <meta name="robots" content={meta.robots || "index,follow"} />
      {meta.canonical ? <link rel="canonical" href={meta.canonical} /> : null}
      <meta property="og:title" content={meta.og_title || meta.title} />
      <meta property="og:description" content={meta.og_description || meta.description || ""} />
      <meta property="og:type" content="article" />
      {meta.og_url ? <meta property="og:url" content={meta.og_url} /> : null}
      {meta.og_image ? <meta property="og:image" content={meta.og_image} /> : null}
      <meta name="twitter:card" content={meta.og_image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={meta.og_title || meta.title} />
      <meta name="twitter:description" content={meta.og_description || meta.description || ""} />
      {meta.og_image ? <meta name="twitter:image" content={meta.og_image} /> : null}
      {schemaJson ? (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schemaJson }} />
      ) : null}
    </>
  );
}
